export const PHONE_NUMBER_REGEX = /^0[789]0-?\d{4}-?\d{4}$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\S]{10,16}$/;

export function validatePhoneNumber(phoneNumber: string): boolean {
  return PHONE_NUMBER_REGEX.test(phoneNumber);
}

export function validateEmail(email: string): boolean {
  return EMAIL_REGEX.test(email);
}

export function validatePassword(password: string): boolean {
  return PASSWORD_REGEX.test(password);
}

export function validateStandardId(id: string): boolean {
  return id.length <= 14;
}

export function validateClientName(name: string): boolean {
  return name.length > 0 && name.length <= 255;
}

export function validateDateRange(from: string, to: string): boolean {
  return new Date(from) < new Date(to);
}

export function validateFutureDate(date: string): boolean {
  return new Date(date) > new Date();
}
